export const comments_4987554 = {"data":{"data":[],"links":{}}}